import type { PropsWithChildren, ReactElement } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

interface IProps {
    text: string;
}

const ManagementPageHeader = ({ text, children }: PropsWithChildren<IProps>): ReactElement => {
    return (
        <Flex
            justifyContent="space-between"
            alignItems="center"
        >
            <Text
                fontVariant="h2"
                color={colorsPalettes.black["0"]}
            >
                {text}
            </Text>

            {children}
        </Flex>
    );
};

export default ManagementPageHeader;
